<div class="product-table-filter-menu" role="dialog" [attr.aria-label]="title()" [formGroup]="filterForm">
  <h2 class="product-table-filter-menu__title">{{ title() }}</h2>

  <fieldset class="product-table-filter-menu__section">
    <legend class="product-table-filter-menu__label">Active Status</legend>
    <div class="product-table-filter-menu__options">
      <se-fe-radios
        class="product-table-filter-menu__control"
        formControlName="status"
        [seFeDataOptions]="statusFilterOptions"></se-fe-radios>
    </div>
  </fieldset>

  @if (showCatalogFilter()) {
    <se-fe-form-field [seFeDataConfig]="catalogFilterConfig">
      <se-fe-select
        formControlName="catalog"
        seFeDataPlaceholder="All Catalogs"
        [seFeDataOptions]="catalogFilterOptions()"
        [seFeDataHideSearchIcon]="true"></se-fe-select>
    </se-fe-form-field>
  }

  <div class="product-table-filter-menu__actions">
    <se-fe-button seFeDataEmphasis="high" [seFeDataFullWidth]="true" (click)="applyFilters()">
      Apply Filters
    </se-fe-button>
    <se-fe-button seFeDataEmphasis="low" [seFeDataFullWidth]="true" (click)="clearFilters()">
      Clear filters
    </se-fe-button>
  </div>
</div>
